import { render, staticRenderFns } from "./ResourceField.vue?vue&type=template&id=7a5953a5&scoped=true&"
import script from "./ResourceField.vue?vue&type=script&lang=ts&"
export * from "./ResourceField.vue?vue&type=script&lang=ts&"
import style0 from "./ResourceField.vue?vue&type=style&index=0&id=7a5953a5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a5953a5",
  null
  
)

export default component.exports